import { Clock } from 'lucide-react';
import { formatInTimeZone } from 'date-fns-tz';

interface UTCTimeDisplayProps {
  currentTime: Date | null;
  isMounted: boolean;
}

export function UTCTimeDisplay({ currentTime, isMounted }: UTCTimeDisplayProps) {
  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Clock className="h-3.5 w-3.5" />
      <span>All date & time displayed in UTC</span>
      {isMounted && currentTime && (
        <>
          <span className="text-muted-foreground/40">•</span>
          <span className="font-mono">
            {formatInTimeZone(currentTime, 'UTC', 'MMM dd, HH:mm:ss')}
          </span>
        </>
      )}
    </div>
  );
}
